import React from 'react'
import type { MouseEventHandler } from 'react'
import styled, { css } from 'styled-components'

import { TResponsiveProps, responsiveStyle } from '@hozana/styling/responsive'

import { RoundButton } from 'elements/button/RoundButton'
import { Div } from 'elements/layout/Div'
import { Overlay } from 'elements/layout/Overlay'
import { Icon } from 'elements/media/Icon'

import { ICON } from 'config/icons'

const responsiveProps = { size: 'width', m: 'margin' } as const

type TStyledDivProps = {
  from: 'top' | 'bottom' | 'left' | 'right'
  open?: boolean
} & TResponsiveProps<typeof responsiveProps>

const StyledDiv = styled(Div)<TStyledDivProps>`
  transition: transform ${({ theme }) => theme.transitions.default};
  overflow: auto;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #dedede;

  ${({ size, from, open, theme }) => {
    const lateral = ['right', 'left'].includes(from)
    const leftRight = open || !lateral ? '0' : from === 'left' ? '-105%' : '105%'
    const topBottom = open || lateral ? '0' : from === 'top' ? '-105%' : '105%'

    return css`
      ${from === 'bottom'
        ? ''
        : css`
            top: 0;
          `};
      ${from === 'top'
        ? ''
        : css`
            bottom: 0;
          `};
      ${from === 'right'
        ? ''
        : css`
            left: 0;
          `};
      ${from === 'left'
        ? ''
        : css`
            right: 0;
          `};
      ${responsiveStyle({ width: 'width', height: 'height' })({ theme, [lateral ? 'width' : 'height']: size })}
      transform: translate3d(${leftRight}, ${topBottom}, 0);
    `
  }}
`

const CloseButton = styled(RoundButton)`
  position: sticky;
  left: 100%;
  top: 0;
  margin-right: 10px;
`

type TPanelProps = TStyledDivProps & {
  close: MouseEventHandler
  back?: () => void
  withOverlay?: boolean
}

export const Panel: TFCC<TPanelProps> = ({ children, close, back, withOverlay, open, ...otherProps }) => (
  <>
    {open && withOverlay && <Overlay onClick={close} />}
    <StyledDiv
      position="fixed"
      zIndex="popover"
      maxH="100%"
      maxW="100%"
      p="1rem 1rem 1rem"
      radius="big"
      w="100%"
      bg="white"
      open={open}
      {...otherProps}
    >
      {close && <CloseButton icon={ICON.CLOSE} onClick={close} size="1.5em" color="black50" bg="white" />}
      {back && <Icon name={ICON.ARROW_LEFT} onClick={back} size="2em" m={'0 0 0 10px'} color="black50" />}
      <Div p={'1rem 1rem 1rem'}>{children}</Div>
    </StyledDiv>
  </>
)
